export default "/_next/static/chunks/fonts/Readex Pro Light-15d7573e3f1e03eff0379aec02ed7bdb.ttf";